import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import Estadisticas from '../../../views/Instalaciones/Estadisticas/Estadisticas';
import Citas from '../../../views/Instalaciones/Citas/Citas';

const Instalaciones = () => {
    return (
        <Routes>
            <Route exact path="/instalaciones/estadisticas"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                          <Estadisticas></Estadisticas>
                       </Suspense>
                   }>
            </Route>
            {/* <Route exact path="/instalaciones/citas"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                          <Citas></Citas>
                       </Suspense>
                   }>
            </Route> */}
        </Routes>
    )

}

export default Instalaciones